import { Link } from "react-router-dom";
import { defaultArticles } from "@/mocks/seoArticle";
import type { SEOArticle } from "@/mocks/seoArticle";

export default function ArticleGrid() {
  const articlesToShow: SEOArticle[] = defaultArticles.slice(0, 9);

  return (
    <section className="py-20 md:py-28 px-6 md:px-12 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-12 md:mb-16">
          <p className="text-xs font-semibold tracking-widest text-foreground-400 uppercase mb-4 font-sans">
            Blog SEO
          </p>
          <h2 className="text-3xl md:text-5xl lg:text-6xl">
            <span className="block font-bold text-foreground-950 font-heading">
              Guides & Conseils
            </span>
            <span className="block italic font-light text-foreground-600 font-heading mt-1">
              Hipobuy Spreadsheet
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articlesToShow.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block rounded-3xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  title={article.title}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/25 to-transparent"></div>
              </div>
              <div className="p-5 md:p-6">
                <p className="text-sm md:text-base font-semibold text-foreground-900 font-sans leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </p>
                <div className="flex items-center gap-2 mt-4">
                  <span className="text-xs text-foreground-400 font-sans">
                    <i className="ri-time-line mr-1"></i>5-8 min
                  </span>
                  <span className="text-xs text-accent-600 font-medium font-sans">
                    Lire l&apos;article
                    <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform inline-block"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/article/guide-complet"
            className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors font-sans font-medium group"
          >
            Voir tous les articles
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}